import React, { useEffect } from "react";
import { Routes, Route, useNavigate } from "react-router-dom";
import { CookiesProvider } from "react-cookie";

// import DOIRedirect from "../../containers/DOIRedirect/DOIRedirect";
import Layout from "../Layout/Layout";

import HomePage from "../../containers/HomePage/HomePage";
import styled from "styled-components";
import Spinner from "../Spinner/Spinner";
import GameDescription from "../../containers/GameDescription/GameDescription";
import PlayGamesIFrame from "../../containers/PlayGamesIFrame/PlayGamesIFrame";
import Cookies from "js-cookie";
import ErrorPage from "../../containers/ErrorPage/ErrorPage";
import Login from "../Login/Login";
import DoiRedirect from "../DoiRedirect";

const DOIRedirect = React.lazy(() =>
  import("../../containers/DOIRedirect/DOIRedirect")
); // Lazy-loaded

const Navigations = () => {
  const nav = useNavigate()

  useEffect(() => {
    const ani = Cookies.get("bubbo-ani");
    if(ani != "null" && ani) {
      nav(`/redirect?msisdn=${ani}`);
    }
  }, [])
  return (
    <React.Suspense
      fallback={
        // <h1>Hwllo</h1>
        <SuspenseStyled>
          <Spinner />
        </SuspenseStyled>
      }
    >
      <CookiesProvider>
        <Layout>
          <Routes>
            <Route path="/" element={<Login service_id={'339'} serviceName={'bobbobgames'}/>} />
            <Route path="/home/:slug" element={<HomePage />} />
            <Route path="/DoiRedirect" element={<DoiRedirect />}/>
            <Route path="/game/:id" element={<GameDescription />} />
            <Route path="/redirect" element={<DOIRedirect />} />
            <Route path="/playgames/:slug" element={<PlayGamesIFrame />} />
            <Route path="*" element={<ErrorPage />} />
          </Routes>
        </Layout>
      </CookiesProvider>
    </React.Suspense>
  );
};

export default Navigations;

const SuspenseStyled = styled.div`
  background-image: linear-gradient(to right, #141e30, #243b55);
  /* background-color: yellow; */
  height: 100vh;
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
`;
